import { useLocation } from "react-router-dom";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const location = useLocation();
  const error = location.state?.error;

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      data-testid="admin-login-page"
      className="bg-linen text-ink font-sans min-h-screen flex items-center justify-center px-6"
    >
      <div className="bg-white border border-cream rounded-3xl shadow-xl p-10 max-w-md w-full text-center">
        <svg className="w-10 h-10 text-forest mx-auto mb-5" viewBox="0 0 32 32" fill="none" aria-hidden="true">
          <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M10 16c2-4 5-6 6-6s4 2 6 6-5 6-6 6-4-2-6-6z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="16" cy="16" r="2.5" fill="currentColor" />
        </svg>
        <h1 className="font-display text-2xl text-ink mb-2">Owner sign-in</h1>
        <p className="text-sm text-moss mb-8">
          Private area for Elisabete — course enquiries and bookings. Students don't need to
          sign in.
        </p>
        {error === "owner-only" && (
          <p data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-3 mb-6">
            This area is reserved for the site owner's Google account.
          </p>
        )}
        {error === "failed" && (
          <p data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-3 mb-6">
            Sign-in didn't complete. Please try again.
          </p>
        )}
        <button
          data-testid="google-signin-button"
          onClick={signIn}
          className="w-full py-3.5 rounded-full bg-forest text-linen text-xs font-semibold uppercase tracking-widest hover:bg-ink transition-colors flex items-center justify-center gap-2"
        >
          <LogIn className="w-4 h-4" />
          Continue with Google
        </button>
        <a
          data-testid="back-to-site-link"
          href="/"
          className="inline-block mt-6 text-xs text-moss hover:text-ink transition-colors"
        >
          ← Back to the course page
        </a>
      </div>
    </div>
  );
}
